export default __webpack_public_path__ + "static/media/BountyHunters FULL 4June.f7758def.png";